import React from 'react';
import UserAvatar from '../Users/UserAvatar';
import CardRow from '../Kanban/CardRow';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Tooltip from '@mui/material/Tooltip'

export default class ProjectCard extends React.Component {
    constructor(props) {
        super(props);

        
        this.state = {
            isTimeDialogOpen: false,
            isOver: false,
            needLogin: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleDragOver = this.handleDragOver.bind(this);
        this.handleCardClick = this.handleCardClick.bind(this);
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.value });
    }

    handleClose() {
        this.setState({ isWorkDialogOpen: false });
    }

    getStyle(provided, style) {
        if (!style) {
            return provided.draggableProps.style;
        }

        return {
            ...provided.draggableProps.style,
            ...style,
        };
    }

    handleDragOver(e) {
        if (e.preventDefault) {
            e.preventDefault(); // Necessary. Allows us to drop.
        }
        if (!this.state.isOver) {
            this.setState({ isOver: true });
        }

        e.dataTransfer.dropEffect = 'move';  // See the section on the DataTransfer object.
        return false;
    }

    handleCardClick(e) {
        if (e.ctrlKey && this.props.onCtrlCardClick) {
            this.props.onCtrlCardClick(this.props.work.id);
        }
    }

    contextTrigger = null;

    render() {
        const { provided, innerRef, style } = this.props;
        return (
            <div className="card-draggable-wrapper"
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                ref={innerRef}
                style={this.getStyle(provided, style)}>
                <div onClick={this.handleCardClick}
                    className={"clearfix project-card-wrapper project-card-wrapper priority-shadow-" + this.props.project.priorityId + (this.state.isOver ? 'over' : '') + (this.props.project.isSelected ? ' selected' : '')}
                
                >
                    <div className="not-pointers">
                        <div className={"clearfix priority-gradient-" + this.props.project.priorityId}>
                            <div className="small-project-card-number" style={{ "background": this.props.project.color }}>
                                <CopyToClipboard onCopy={() => { this.setState({ snackbarOpen: true, newNotify: 'Скопировано в буфер обмена' }); }} text={document.location.origin + '/board?project=' + encodeURIComponent(this.props.project.id)}>
                                    <span>{this.props.project.name}</span>
                                </CopyToClipboard>
                                <Tooltip title={this.props.project.priority} className={"project-priority-marker-" + this.props.project.priorityId}>
                                    <div/>
                                </Tooltip>
                            </div>
                        </div>
                        <div onClick={(e) => { !e.ctrlKey && this.props.onCardOpen(this.props.project) }}>
                            <CardRow>
                                <div className="two-third-block">
                                    <div className="project-card-plan">Согласовано {this.props.project.approvedHours}ч</div>
                                    <div className="project-card-plan">План {this.props.project.planHours}/{this.props.project.clientHours}ч</div>
                                    <div className="project-card-plan">Потрачено {this.props.project.factHours.toFixed(1)}ч</div>
                                </div>
                                <div className="work-card-avatar-block">{this.props.project.ownerId && <UserAvatar userId={this.props.project.ownerId} />}</div>
                            </CardRow>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
